(function() {
	'use strict';

	angular.module('quantixApp').factory('FinancialSensitivityUnlistedService',
			FinancialSensitivityUnlistedService);

	FinancialSensitivityUnlistedService.$inject = [ '$resource', '$q', '$http' ];

	function FinancialSensitivityUnlistedService($resource, $q, $http) {

		
	
		
		
		
		var _getLandingPageData = function(ybmFlag) {
			
			
		  var deferred = $q.defer();

			var url = 'api/financialSensitivity/getLandingPageDataForUnlisted';

			$http.post(url,ybmFlag).then(function(response) {

				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		
		
		var _getFinancialCompanyDataPresentOrNotForUnlisted = function(companyCode,companyflag) {
			var data={companyCode:companyCode,companyflag:companyflag};
			var deferred = $q.defer();
			var url = 'api/financialSensitivity/getFinancialCompanyDataPresentOrNotForUnlisted';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
            }, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
	
		var _getAnalyticsCompanyDetailsForUnlisted = function(companyCode,units,companyIndustryId,sensitivitySegmentId,conFlag,ybmFlag) {

			var deferred = $q.defer();
			var data = {
					companyCode : companyCode,
					units : units,
					companyIndustryId : companyIndustryId,
					segmentName : sensitivitySegmentId,
					consolidatedFlag : conFlag,
					ybmFlag:ybmFlag
				};
				
			var url = 'api/financialSensitivity/getAnalyticsCompanyDetailsForUnlisted';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _financialSensitivityExportModelForUnlistedCIR = function(fd) {
			var deferred = $q.defer();
			var filePathURL = 'api/financialSensitivityUnlisted/financialSensitivityExportModelForCIRUnlisted';
			
			$http.post(filePathURL, fd, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}
		return {

			
			getLandingPageData:_getLandingPageData,
			
			getFinancialCompanyDataPresentOrNotForUnlisted : _getFinancialCompanyDataPresentOrNotForUnlisted,
			
			getAnalyticsCompanyDetailsForUnlisted : _getAnalyticsCompanyDetailsForUnlisted,
			financialSensitivityExportModelForUnlistedCIR : _financialSensitivityExportModelForUnlistedCIR
			
		};

	}
})();
